export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6239.cb9b5b9b.jpg";